import React from 'react';
import { Clock, Shield, Users, Utensils, Heart, Zap } from 'lucide-react';

export const mockData = {
  images: {
    hero: 'https://images.unsplash.com/photo-1474302770737-173ee21bab63?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxwcml2YXRlJTIwamV0fGVufDB8fHx8MTc2NTA0NjYyNXww&ixlib=rb-4.1.0&q=85',
    interior: '/interior.jpg',
    exterior: 'https://images.unsplash.com/photo-1619659085985-f51a00f0160a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxwcml2YXRlJTIwamV0fGVufDB8fHx8MTc2NTA0NjYyNXww&ixlib=rb-4.1.0&q=85',
    businessJet1: 'https://images.unsplash.com/photo-1540962351504-03099e0a754b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGpldHxlbnwwfHx8fDE3NjUwNDY2MzB8MA&ixlib=rb-4.1.0&q=85',
    businessJet2: 'https://images.unsplash.com/photo-1635672033263-a19f27eaefa8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMGpldHxlbnwwfHx8fDE3NjUwNDY2MzB8MA&ixlib=rb-4.1.0&q=85',
    engineDetail: 'https://images.unsplash.com/photo-1635668422724-fffb2201f951?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMGpldHxlbnwwfHx8fDE3NjUwNDY2MzB8MA&ixlib=rb-4.1.0&q=85',
    inflight: 'https://images.unsplash.com/photo-1678419214383-2391a9118c24?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMGpldHxlbnwwfHx8fDE3NjUwNDY2MzB8MA&ixlib=rb-4.1.0&q=85',
    luxuryInterior: 'https://images.pexels.com/photos/14914173/pexels-photo-14914173.jpeg'
  },
  
  advantages: [
    {
      title: 'Garantierte Verfügbarkeit',
      description: 'Wenn Sie buchen, fliegen Sie genau das Flugzeug, das Sie erwarten. Keine Überraschungen.'
    },
    {
      title: 'Höchste Sicherheitsstandards',
      description: 'Wartung und Crew-Training liegen in unserer Hand. Ihre Sicherheit ist unser oberstes Gebot.'
    },
    {
      title: 'Persönlicher Service',
      description: 'Wir kennen Ihre Präferenzen: Lieblingswein, gewünschte Temperatur an Bord – wir erinnern uns.'
    }
  ],
  
  features: [
    {
      title: 'Midsize-Komfort',
      description: 'Rumpf aus Carbon-Verbundwerkstoff ermöglicht eine breitere und höhere Kabine als bei vergleichbaren Jets. "Stand-up Cabin"-Freiheit mit 1,65m Höhe, Platz für bis zu 6 Passagiere.',
      spec: '1,65m Kabinenhöhe',
      image: '/interior.jpg'
    },
    {
      title: 'Geschwindigkeit',
      description: 'Reisegeschwindigkeit von über 830 km/h (450 kts) – schneller ans Ziel als die meisten Konkurrenten ihrer Klasse. München nach London ist ein Katzensprung.',
      spec: '> 830 km/h',
      image: '/exterior.jpg'
    },
    {
      title: 'Modernste Avionik',
      description: 'Die Kabine ist nicht nur geräumiger, sondern auch leiser. Perfekt zum konzentrierten Arbeiten oder Entspannen in absoluter Ruhe.',
      spec: 'Leiseste Kabine',
      image: 'https://images.unsplash.com/photo-1635668422724-fffb2201f951?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMGpldHxlbnwwfHx8fDE3NjUwNDY2MzB8MA&ixlib=rb-4.1.0&q=85'
    }
  ],
  
  comparison: [
    {
      feature: 'Flugzeugtyp',
      standard: 'Oft Ungewissheit ("Category: Light Jet")',
      executive: 'Garantiert Beechcraft Premier 1A'
    },
    {
      feature: 'Kabinenraum',
      standard: 'Oft eng (muss gebückt betreten werden)',
      executive: 'Geräumigste Kabine der Klasse (Stand-up)'
    },
    {
      feature: 'Geschwindigkeit',
      standard: 'Durchschnittlich ca. 700 km/h',
      executive: 'High-Speed Cruise ca. 830 km/h'
    },
    {
      feature: 'Ansprechpartner',
      standard: 'Call-Center Agenten',
      executive: 'Direkter Kontakt zum Operations-Team'
    },
    {
      feature: 'Flotten-Redundanz',
      standard: 'Variabel',
      executive: '3 eigene Flugzeuge als Backup'
    }
  ],
  
  services: [
    {
      title: 'Executive Catering',
      description: 'Von leichten Snacks bis zum First-Class Menü. Wir richten uns nach Ihrem Geschmack – Ihr Lieblingsrestaurant über den Wolken.',
      image: '/interior.jpg',
      icon: <Utensils className="w-6 h-6 text-red-600" />
    },
    {
      title: 'Pets on Board',
      description: 'Ihr Haustier fliegt selbstverständlich in der Kabine mit – nicht im Frachtraum. Komfort für die ganze Familie.',
      image: '/exterior2.jpg',
      icon: <Heart className="w-6 h-6 text-red-600" />
    },
    {
      title: '15-Minuten Boarding',
      description: 'Kein Warten in Warteschlangen. Ankunft am GAT (General Aviation Terminal) und Abflug 15 Minuten später.',
      image: 'https://images.unsplash.com/photo-1635672033263-a19f27eaefa8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMGpldHxlbnwwfHx8fDE3NjUwNDY2MzB8MA&ixlib=rb-4.1.0&q=85',
      icon: <Zap className="w-6 h-6 text-red-600" />
    }
  ]
};